<template>
  <v-card>
    <v-card-title class="headline">Allow GPU Algo Node</v-card-title>
    <v-card-text>{{allow_gpu_algo_node}}</v-card-text>

    <v-card-title class="headline">Max Algo Node Count</v-card-title>
    <v-card-subtitle>Max algo node count is ignored when it is 0.</v-card-subtitle>
    <v-card-text>{{max_algo_node_count}}</v-card-text>

    <v-card-title class="headline">Max Lidar Count</v-card-title>
    <v-card-subtitle>Max lidar count is ignored when it is 0.</v-card-subtitle>
    <v-card-text>{{max_lidar_count}}</v-card-text>

    <v-card-title class="headline">Lidars Info</v-card-title>
    <v-card-text>
      <v-list-item v-for="(item, i) in lidars" :key="i">
        <v-list-item-content>
          <v-list-item-title>{{item[0]}} <span class="accent--text">{{item[1]}} units</span> </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>

    <v-card-title class="headline">Allow Features</v-card-title>
    <v-card-text>
      <v-list-item v-for="(item, i) in allow_features" :key="i">
        <v-list-item-content>
          <v-list-item-title>{{item}} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>

    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn color="primary" class="sr_gray--text" text @click="$emit('closeDialog')" >Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    props: [
      'allow_gpu_algo_node', 'max_algo_node_count', 'max_lidar_count', 'lidars', 'allow_features', 'value'
    ],
  }
</script>
